import { Controller, useFormContext } from "react-hook-form";

import { FieldErrors } from "src/api/types";
import { Card } from "src/base-components/Card";
import { AutocompleteCodeInput } from "src/base-components/CodeInput/EditorCodeInput";
import { CustomTitle } from "src/entityActionNodes/LocateEntityCard";
import { WriteEntityNodeForm } from "src/entityActionNodes/WriteEntityNodeEditor";

export const LocateWriteEntityCard = ({
  immutable,
  fieldErrors,
}: {
  immutable: boolean;
  fieldErrors: FieldErrors;
}) => {
  const { control, getValues } = useFormContext<WriteEntityNodeForm>();
  const entityObjectsFieldId = getValues("entity_objects_expression.id");
  const entityObjectsError = fieldErrors[entityObjectsFieldId];

  return (
    <Card>
      <Card.Header className="flex items-center gap-x-3">
        <CustomTitle
          description="Select the data field that contains the Entity object(s) in this Decision Flow. If an Entity with the same ID exists, it will be updated; otherwise, a new Entity will be created."
          title="Locate the Entity"
          required
        />
      </Card.Header>
      <Card.Content className="space-y-4">
        <Controller
          control={control}
          name="entity_objects_expression.value"
          render={({ field }) => (
            <AutocompleteCodeInput
              dataLoc="entity-objects-expression"
              disabled={immutable}
              error={entityObjectsError}
              placeholder="data.entity_object(s)"
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </Card.Content>
    </Card>
  );
};
